import React from "react";
import { useSelector } from "react-redux";

import { Box, Container, FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import { Typography } from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

import { AnchorLink, StyledApplySection, DynamicText } from "./style";

function ApplySection({ applySectionRef }) {
  const { jobData } = useSelector((state) => state.careersPage);

  const {
    title,
    sub_title: subTitle,
    description,
    email,
    number,
  } = jobData?.forms || {};

  return (
    <StyledApplySection ref={applySectionRef}>
      <Container className="container">
        <Box className="apply-section">
          <Typography
            variant="heading2"
            className="title"
            color={theme.colorsV2.gray.shade_800}
          >
            {title}
          </Typography>
          {subTitle && <Typography variant="paragraph2">{subTitle}</Typography>}
          {description && (
            <DynamicText
              variant="label1"
              fontFamily="var(--man-700)"
              className="description"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
          {(number || email) && (
            <FlexDiv flexDirection="column" alignItems="flex-start">
              {number && (
                <AnchorLink href={`tel:${number}`}>
                  <StyledSvgSprite
                    icon="icon-phone-2"
                    fill={theme.colorsV2.shyft.purple_text}
                    height="16px"
                    width="16px"
                    mr="16px"
                  />
                  <Typography
                    variant="label2"
                    color={theme.colorsV2.gray.shade_700}
                  >
                    {number}
                  </Typography>
                </AnchorLink>
              )}
              {email && (
                <AnchorLink href={`mailto:${email}`}>
                  <StyledSvgSprite
                    icon="icon-EnvelopeSimple"
                    fill={theme.colorsV2.shyft.purple_text}
                    height="16px"
                    width="16px"
                    mr="16px"
                  />
                  <Typography
                    variant="label2"
                    color={theme.colorsV2.gray.shade_700}
                  >
                    {email}
                  </Typography>
                </AnchorLink>
              )}
            </FlexDiv>
          )}
        </Box>
      </Container>
    </StyledApplySection>
  );
}

export default ApplySection;
